import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Divider, Grid, TextareaAutosize, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DropDown from "../../../Components/DropDown/DropDown";
import MuiInputField from "../../../Components/InputField/InputField";
import AddButton from "../../../Components/AddButton/AddButton";
import { isEmpty } from "../../../Utils/helper";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function AlertPopUp(props) {
  return (
    <Box
      sx={{
        ...style,
        width: 400,
        border: "1px solid lightgray",
        height: 200,
        borderRadius: "15px",
        outline: "none",
        padding: 0,
      }}
    >
      <Grid container justifyContent="flex-end" alignItems={"center"}>
        <Box
          onClick={() =>
            props.setOpenModal({
              isOpen: false,
            })
          }
          sx={{
            width: 20,
            height: 20,
            backgroundColor: "#adbdd6",
            borderRadius: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <CloseIcon
            sx={{
              width: 15,
              color: "white",
            }}
          />
        </Box>
      </Grid>
      <Grid>
        <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
          {props?.headText}
        </Typography>
      </Grid>
      <Grid
        container
        item
        lg={11.5}
        height={"90px"}
        justifyContent="center"
        alignItems={"center"}
        sx={{ gap: "5px" }}
      >
        {props?.data.buttons.map((item) => {
          return (
            <Button>
              <Box
                onClick={() => {
                  if (item.buttonName === "No") {
                    props?.setOpenModal({ isOpen: false });
                  } else if (item.buttonName == "Yes") {
                    props.handleYes();
                  }
                }}
                sx={{
                  padding: "10px 30px",
                  borderRadius: "6px",
                  border: item.buttonName === "No" ? "1px solid black" : "none",
                  backgroundColor:
                    item.buttonName === "No"
                      ? "#fff"
                      : props.warning
                      ? "red"
                      : "#17dfba",
                  textTransform: "capitalize",
                }}
              >
                <Typography
                  sx={{
                    color: item.buttonName === "No" ? "#000" : "white",
                  }}
                >
                  {item.buttonName}
                </Typography>
              </Box>
            </Button>
          );
        })}
      </Grid>
    </Box>
  );
}

export default function HospitalPopUp({ setOpenModal, openModal, data }) {
  const handleClose = () => {
    setOpenModal({ isOpen: false });
  };

  const [reason, setReason] = React.useState("");

  return (
    <div style={{ display: "none" }}>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        {data?.data?.type == "FLAG" ? (
          <Box
            sx={{
              ...style,
              width: 500,
              border: "1px solid lightgray",
              height: 300,
              borderRadius: "15px",
              outline: "none",
              padding: "15px",
            }}
          >
            <Grid
              container
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Grid>
                <Typography sx={{ textAlign: "center", fontWeight: "bold" }}>
                  {data.data?.headText}
                </Typography>
              </Grid>
              <Box
                onClick={() =>
                  setOpenModal({
                    isOpen: false,
                  })
                }
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: "#adbdd6",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "10px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
              >
                <CloseIcon
                  sx={{
                    width: 15,
                    color: "white",
                  }}
                />
              </Box>
            </Grid>

            <Grid>
              <Typography
                sx={{
                  textAlign: "start",
                  fontWeight: "bold",
                  marginTop: "30px",
                  marginBottom: "5px",
                  color: "grey",
                }}
              >
                Add Reason
              </Typography>
              <TextareaAutosize
                minRows={8}
                maxRows={12}
                placeholder="Enter your text here..."
                value={reason}
                onChange={(event) => {
                  setReason(event.target.value);
                }}
                style={{ width: "97%", marginBottom: "10px" }}
              />
            </Grid>

            <Grid
              container
              item
              lg={12}
              justifyContent="flex-end"
              alignItems={"flex-end"}
              sx={{ gap: "5px" }}
            >
              {data?.data.buttons.map((item) => {
                return (
                  <Button>
                    <Box
                      onClick={() => {
                        if (item.buttonName === "Cancel") {
                          setOpenModal({ isOpen: false });
                        } else if (item.buttonName == "Add") {
                          data?.data?.handleApprove(
                            data.data.checked,
                            data.data.index,
                            reason
                          );
                          setReason("");
                          setOpenModal({ isOpen: false });
                        }
                      }}
                      sx={{
                        padding: "10px 30px",
                        borderRadius: "6px",
                        backgroundColor:
                          item.buttonName === "Cancel" ? "grey" : "#17dfba",
                        textTransform: "capitalize",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "white",
                        }}
                      >
                        {item.buttonName}
                      </Typography>
                    </Box>
                  </Button>
                );
              })}
            </Grid>
          </Box>
        ) : (
          <AlertPopUp
            headText={
              data?.data?.type == "DELETE"
                ? "Are you sure want to delete?"
                : data?.data?.type == "FLAG"
                ? "Are you sure want to Flag?"
                : data?.data?.checked
                ? "Are you sure want to approve?"
                : "Are you sure want to un approve"
            }
            setOpenModal={setOpenModal}
            handleYes={() => {
              if (data?.data?.type == "DELETE") {
                data?.data?.deleteData(data?.data?.deleteId);
                setOpenModal({ isOpen: false });
              } else {
                data.data.handleApprove(data.data.checked, data.data.index);
                setOpenModal({ isOpen: false });
              }
            }}
            warning={data?.data?.type == "DELETE"}
            data={data.data}
          ></AlertPopUp>
        )}
      </Modal>
    </div>
  );
}
